export const routeAcoes = (routes, checkAuth) => {
    routes.push(
        {
            path: "/logs-radius",
            component: () =>
                import(/* webpackChunkName: "acoes_logs_radius" */ "../pages/acoes/LogsRadius"),
            beforeEnter: checkAuth
        },
        {
            path: "/icinga",
            component: () =>
                import(/* webpackChunkName: "acoes_icinga" */ "../pages/acoes/Icinga"),
            beforeEnter: checkAuth
        },
        {
            path: "/importar-kmz",
            component: () =>
                import(/* webpackChunkName: "acoes_importar_kmz" */ "../pages/acoes/ImportarKMZ"),
            beforeEnter: checkAuth
        },
        {
            path: "/burst",
            component: () =>
                import(/* webpackChunkName: "burst" */ "../pages/acoes/Burst"),
            beforeEnter: checkAuth
        },
        {
            path: "/comandos-todos",
            component: () =>
                import(/* webpackChunkName: "comandos_todos" */ "../pages/acoes/ComandosTodos"),
            beforeEnter: checkAuth
        },
        {
            path: "/comandos-todos-concentradores",
            component: () =>
                import(/* webpackChunkName: "comandos_todos_concentradores" */ "../pages/acoes/ComandosTodosConcentradores"),
            beforeEnter: checkAuth
        },
        {
            path: "/config",
            component: () =>
                import(/* webpackChunkName: "configuracoes" */ "../pages/acoes/Configuracoes"),
            beforeEnter: checkAuth
        }
    );
};
